import moment from "moment";

export const truncate = (str, n) => {
  return str.length > n ? `${str.substr(0, n - 1)}...` : str;
};

export const toPercent = (value, max) => {
  return Math.ceil((value * 100) / max);
};

export const queryStringFromArray = (values, separator) => {
  const valuesWithSeparator = values.map((v) => `${separator}=${v}`);
  return valuesWithSeparator.join("&");
};

export const download = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const filenameDownloadTable = (
  entityName = null,
  assetName = null,
  cartographyId = null,
  tableName = null,
  extension = "csv"
) => {
  const date = moment().format("YYYY-MM-DD");
  const _entityName = entityName ? `${entityName.replace(/\s/g, "-")}-` : "";
  const _assetName = assetName ? `${assetName.replace(/\s/g, "-")}-` : "";
  const _tableName = tableName ? `${tableName}-` : "";
  const filename = `${_entityName}${_assetName}${_tableName}${date}.${extension}`;
  return filename;
};
